export default __webpack_public_path__ + "static/media/news-18.b64f6fe5.jpeg";